var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletconnect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_107_269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2398 18.214C21.3916 10.0064 34.6084 10.0064 42.7603 18.214L43.7414 19.2018C44.149 19.6122 44.149 20.2775 43.7414 20.6879L40.3853 24.067C40.1815 24.2721 39.8511 24.2721 39.6473 24.067L38.2972 22.7076C32.6102 16.9818 23.3899 16.9818 17.7029 22.7076L16.2571 24.1634C16.0533 24.3685 15.7228 24.3685 15.5191 24.1634L12.1629 20.7843C11.7553 20.3739 11.7553 19.7086 12.1629 19.2982L13.2398 18.214ZM49.7011 25.2022L52.688 28.2096C53.0956 28.62 53.0956 29.2853 52.688 29.6957L39.2197 43.2564C38.8121 43.6668 38.1512 43.6668 37.7436 43.2564C37.7436 43.2564 37.7436 43.2564 37.7436 43.2564L28.1846 33.632C28.0827 33.5294 27.9175 33.5294 27.8156 33.632C27.8156 33.632 27.8156 33.632 27.8156 33.632L18.2568 43.2564C17.8492 43.6668 17.1884 43.6668 16.7808 43.2564C16.7808 43.2564 16.7807 43.2564 16.7807 43.2564L3.31201 29.6956C2.90442 29.2852 2.90442 28.6198 3.31201 28.2094L6.29897 25.2021C6.70656 24.7917 7.3674 24.7917 7.77499 25.2021L17.3342 34.8266C17.4361 34.9292 17.6013 34.9292 17.7032 34.8266C17.7032 34.8266 17.7032 34.8266 17.7032 34.8266L27.2619 25.2021C27.6694 24.7917 28.3303 24.7917 28.7379 25.202C28.7379 25.202 28.7379 25.202 28.7379 25.202L38.297 34.8266C38.3989 34.9292 38.5642 34.9292 38.666 34.8266L48.225 25.2022C48.6326 24.7919 49.2935 24.7919 49.7011 25.2022Z",
    fill: "#3B99FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_107_269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 31.7073,
    fill: "white",
    transform: "translate(3 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletconnect);
export default __webpack_public_path__ + "static/media/walletconnect.0c897697b90d13feb33f8e39544244b0.svg";
export { ForwardRef as ReactComponent };